import { ReportClassificationRepository } from '../domain/repository/ReportClassificationRepository'
import { useQuery } from 'react-query'
import { ReportClassification } from '../domain/ReportClassification'

export const useReportClassificationFindAllQuery = (
	reportClassificationRepository: ReportClassificationRepository,
	{
		onSuccess,
		onError,
	}: {
		onSuccess?: (reportClassification: ReportClassification[]) => void
		onError?: (error: unknown) => void
	} = {}
) => {
	return useQuery('report-classification-find-all-query', () => reportClassificationRepository.findAll(), {
		staleTime: 0,
		onSuccess,
		onError,
	})
}
